// === Central App State ===

// Completions are now stored per calendar year as { [taskId]: year } so a
// task marked done resets automatically on Jan 1 (see completion-service.js).
export const STORAGE_KEY_DONE = 'farm_adv_done_v15';
export const LEGACY_DONE_KEY = 'farm_adv_done_v14'; // old format: array of ids
export const PROFILE_KEY = 'farm_profile_v1';
export const SEASONS_KEY = 'farm_seasons_v1';
export const MONTH_OVERRIDES_KEY = 'farm_month_overrides_v1';
export const DEFAULT_PROFILE = { herdType: '' };
export const DEFAULT_SEASONS = {
  calving: null,
  turnout: null,
  housing: null,
  breeding: null,
  dryingOff: null
};

const store = {
  seed: [],
  currentMonth: new Date().getMonth(),
  // Per-task completion year: { [taskId]: year }. A task counts as done only
  // for the current calendar year; resets automatically when the year rolls.
  completions: {},
  currentView: 'grid',
  farmProfile: { ...DEFAULT_PROFILE },
  pendingProfile: { ...DEFAULT_PROFILE },
  farmSeasons: { ...DEFAULT_SEASONS },
  pendingSeasons: { ...DEFAULT_SEASONS },
  // Per-task month overrides: { [taskId]: monthIndex0 }. When set, a task
  // shows only in that month instead of its default/anchor-shifted months.
  monthOverrides: {}
};

export default store;
